import { PickSessionViewSchema } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const getPickSessionFilters = {
  name: "getPickSessionFilters" as const,
  input: z.object({}),
  output: z.object({ filters: z.array(PickSessionViewSchema) }),
};
